import React from "react";
import { Box } from "@mui/material";
import { Theme } from "../../../../providers/ThemeProvider";
import useTheme from "../../../../common/hooks/useTheme";
import { ActiveCompound } from "../../../new-reports/types/newReportTypes";

type Props = {
  activeCompounds: ActiveCompound[] | undefined;
  label: string;
  // Optional font size overrides
  fontSizes?: {
    sectionTitle?: string;
    compoundText?: string;
  };
};

const ServiceActiveCompoundsSection = ({
  activeCompounds,
  label,
  fontSizes,
}: Props) => {
  const theme: Theme = useTheme();

  // Default font sizes (from ServicePage)
  const defaultFontSizes = {
    sectionTitle: "11px",
    compoundText: "9px",
  };

  // Merge with provided overrides
  const sizes = { ...defaultFontSizes, ...fontSizes };

  if (!activeCompounds || activeCompounds.length === 0) {
    return null;
  }

  return (
    <Box sx={styles.section}>
      <Box component="p" sx={styles.sectionTitle(theme, sizes.sectionTitle)}>
        {label}
      </Box>
      <Box sx={styles.activeCompoundsBox(theme)}>
        <Box component="p" sx={styles.activeCompoundsText(theme, sizes.compoundText)}>
          {activeCompounds.map((compound, idx) => (
            <Box component="span" key={idx}>
              <Box component="span" sx={styles.compoundName}>
                {compound.name}:{" "}
              </Box>
              <Box component="span">
                {compound.value}
                {compound.unit}
                {idx < activeCompounds.length - 1 ? " / " : ""}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceActiveCompoundsSection;

const styles = {
  section: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "8px",
  },
  sectionTitle: (theme: Theme, fontSize: string) => ({
    fontFamily: "var(--font-Regular)",
    fontSize,
    lineHeight: "normal",
    color: theme.colorTokens.N[90],
    margin: 0,
  }),
  activeCompoundsBox: (theme: Theme) => ({
    backgroundColor: theme.colorTokens.N[30],
    borderRadius: "8px",
    padding: "12px",
  }),
  activeCompoundsText: (theme: Theme, fontSize: string) => ({
    fontFamily: "var(--font-Light)",
    fontSize,
    lineHeight: "14px",
    color: theme.colorTokens.N[90],
    margin: 0,
  }),
  compoundName: {
    fontFamily: "var(--font-Regular)",
  },
};
